import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ConnectionService } from 'src/app/connection.service';
import { WalletserviceService } from 'src/app/services/walletservice.service';
import * as Highcharts from 'highcharts';
import { SocketService } from 'src/app/services/socket.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-contract-charts',
  templateUrl: './contract-charts.component.html',
  styleUrls: ['./contract-charts.component.css']
})
export class ContractChartsComponent implements OnInit {
  priceValue: any[];
  calls: any[];
  concalls: any;
  element: any;
  conCount: any;
  topcalls: any;
  topconcalls: any[];

  // chartColor = (localStorage.getItem("Sastana-Theme") == 'darktheme') ? '#000000' : '#ffffff';
  // piechartColor = (localStorage.getItem("Sastana-Theme") == 'darktheme') ? '#2740a6' : '#2740a6';
  contopCount: any;
  chartColor: string;
  piechartColor: string;

  constructor(private walletservice: WalletserviceService, private conn: ConnectionService, private alert: ToastrService, private activatedRoute: ActivatedRoute, private router: Router,private socketService: SocketService,private spinner : NgxSpinnerService) { 
    this.conn.themes.subscribe(resData => {
      setTimeout(() => {
        if (resData) {
          this.chartColor = (resData == 'darktheme') ? '#000000' : '#ffffff';
          this.piechartColor = (resData == 'darktheme') ? '#2740a6' : '#ffffff';
        }
      }, 4000);
    });
  }

  ngOnInit() {
    this.contractCalls()
    this.topCalls()
  }

  contractCalls() {
    // this.spinner.show()
    this.calls = []
    this.conn.postUrl('users/contractChart', {}).subscribe((chartres: any) => {
      // this.spinner.hide()

      this.concalls = chartres.data
      let categoriesData = []
      for (let index = 0; index < this.concalls.length; index++) {
        this.element = this.concalls[index];
        this.conCount = this.element.Count
        this.calls.push(this.conCount)
        categoriesData.push(this.concalls[index].monthInName)
        this.concallschart(categoriesData);
      }
    })
  }

  topCalls() {
    this.topconcalls = []
    this.conn.postUrl('users/topContract', {}).subscribe((chartres: any) => {
      this.topcalls = chartres.data
      let categoriesData = []
      for (let index = 0; index < this.topcalls.length; index++) {
        this.element = this.topcalls[index];
        this.contopCount = this.element.callCount
        this.topconcalls.push(this.contopCount)
        categoriesData.push(this.topcalls[index].name)
      this.topContractCall(categoriesData);
      }
    })
  }


  concallschart(category: any) {
    Highcharts.chart('contract_call', {
      chart: {
        type: 'area'
      },
      accessibility: {
        description: '',
      },
      title: {
        text: ''
      },
      subtitle: {
        text: ''
      },
      xAxis: {
        categories: category
      },
      yAxis: {
        title: {
          text: ''
        },
      },
      tooltip: {
        pointFormat: '{series.name} <b>{point.y}</b><br/>',
        style :{
          backgroundColor:'#ffffff'
        }
      },
      plotOptions: {
        area: {
          marker: {
            enabled: false,
            symbol: 'circle',
            radius: 2,
            states: {
              hover: {
                enabled: true
              }
            }
          }
        }
      },
      series: [{
        name: 'Number of calls',
        color: '#2740a6',
        data: this.calls
      }],
    } as any);
  }

  topContractCall(category: any) {
    Highcharts.chart('top_contract', {
      chart: {
        backgroundColor: this.chartColor,
        type: 'column',
        width: 500,
        height: 400
      },
      title: {
        text: ''
      },
      xAxis: {
        categories: category,
        crosshair: true,
      },
      yAxis: {
        min: 0,
        title: {
          text: ''
        }
      },
      tooltip: {
        pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
          '<td style="padding:0"><b>{point.y}</b></td></tr>',
        style: {
          backgroundColor: '#ffffff'
        }
      },
      plotOptions: {
        column: {
          pointPadding: 0.2,
          borderWidth: 0
        }
      },
      series: [{
        name: 'Number of Calls',
        type: 'column',
        color: '#2740a6',
        data: this.topconcalls
      }
      ]
    });
  }

  // topContractCall(category: any) {
  //   Highcharts.chart('top_contract', {
  //     chart: {
  //       backgroundColor: this.chartColor,
  //       type: 'column',
  //       // width: 500,
  //       // height: 380
  //     },
  //     title: {
  //       text: ''
  //     },
  //     xAxis: {
  //       categories: category,
  //       crosshair: true
  //     },
  //     yAxis: {
  //       min: 0,
  //       title: {
  //         text: ''
  //       }
  //     },
  //     tooltip: {
  //       // headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
  //       pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
  //         '<td style="padding:0"><b>{point.y} </b></td></tr>',
  //       // footerFormat: '</table>',
  //       // shared: true,
  //       // useHTML: true
  //       style :{
  //         backgroundColor:'#ffffff'
  //       }
  //     },
  //     plotOptions: {
  //       column: {
  //         pointPadding: 0.2,
  //         borderWidth: 0
  //       }
  //     },
  //     series: [{
  //       name: 'Number of Calls',
  //       type: 'column',
  //       color: '#2740a6',
  //       data: this.topconcalls
  //     }
  //     ]
  //   });
  // }

}
